import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import DashboardLayout from "@/pages/DashboardLayout";

const lazyPage = (loader) => lazy(loader);
const Pricing = lazyPage(() => import("@/pages/Pricing"));
const AfricanMarkets = lazyPage(() => import("@/pages/AfricanMarkets"));
const VirtusTrade = lazyPage(() => import("@/pages/VirtusTrade"));
const AdminRevenue = lazyPage(() => import("@/pages/AdminRevenue"));
const YieldDesk = lazyPage(() => import("@/pages/YieldDesk"));
const LiveData = lazyPage(() => import("@/pages/LiveData"));
const BillingReturn = lazyPage(() => import("@/pages/BillingReturn"));
const PasswordReset = lazyPage(() => import("@/pages/PasswordReset"));
const DashboardHome = lazyPage(() => import("@/pages/DashboardHome"));
const MarketOutlook = lazyPage(() => import("@/pages/MarketOutlook"));
const SignalDesk = lazyPage(() => import("@/pages/SignalDesk"));
const VirtusSignal = lazyPage(() => import("@/pages/VirtusSignal"));
const ResearchTools = lazyPage(() => import("@/pages/ResearchTools"));
const RoughPricing = lazyPage(() => import("@/pages/RoughPricing"));
const PolishedPricing = lazyPage(() => import("@/pages/PolishedPricing"));
const Auctions = lazyPage(() => import("@/pages/Auctions"));
const ODC = lazyPage(() => import("@/pages/ODC"));
const Macro = lazyPage(() => import("@/pages/Macro"));
const Orders = lazyPage(() => import("@/pages/Orders"));
const MyOrders = lazyPage(() => import("@/pages/MyOrders"));
const Registry = lazyPage(() => import("@/pages/Registry"));
const ApiAccess = lazyPage(() => import("@/pages/ApiAccess"));
const Memos = lazyPage(() => import("@/pages/Memos"));
const News = lazyPage(() => import("@/pages/News"));
const Alerts = lazyPage(() => import("@/pages/Alerts"));
const Admin = lazyPage(() => import("@/pages/Admin"));
const AboutData = lazyPage(() => import("@/pages/AboutData"));
const About = lazyPage(() => import("@/pages/About"));
const Terms = lazyPage(() => import("@/pages/Terms"));
const LeadLanding = lazyPage(() => import("@/pages/LeadLanding"));
const Indices = lazyPage(() => import("@/pages/Indices"));
const PriceReference = lazyPage(() => import("@/pages/PriceReference"));
const Producers = lazyPage(() => import("@/pages/Producers"));
const Brief = lazyPage(() => import("@/pages/Brief"));
const Archive = lazyPage(() => import("@/pages/Archive"));
const VerifiedData = lazyPage(() => import("@/pages/VerifiedData"));
const OriginPremium = lazyPage(() => import("@/pages/OriginPremium"));
const DisciplineScorecard = lazyPage(() => import("@/pages/DisciplineScorecard"));
const DealRoom = lazyPage(() => import("@/pages/DealRoom"));
const InvestmentStones = lazyPage(() => import("@/pages/InvestmentStones"));
const AccuracyDesk = lazyPage(() => import("@/pages/AccuracyDesk"));
const StrategicBriefs = lazyPage(() => import("@/pages/StrategicBriefs"));
const FiscalMonitor = lazyPage(() => import("@/pages/FiscalMonitor"));
const WeeklyBrief = lazyPage(() => import("@/pages/WeeklyBrief"));
const Inventory = lazyPage(() => import("@/pages/Inventory"));
const OrderNew = lazyPage(() => import("@/pages/OrderNew"));
const OrderTrack = lazyPage(() => import("@/pages/OrderTrack"));
const AdminCommerce = lazyPage(() => import("@/pages/AdminCommerce"));
const CentreOfExcellence = lazyPage(() => import("@/pages/CentreOfExcellence"));
const Wire = lazyPage(() => import("@/pages/Wire"));
const Provenance = lazyPage(() => import("@/pages/Provenance"));
const ProvenanceArchive = lazyPage(() => import("@/pages/Provenance").then((m) => ({ default: m.ProvenanceArchive })));
const Collection = lazyPage(() => import("@/pages/Collection"));
const RegistryPublic = lazyPage(() => import("@/pages/RegistryPublic"));
const YieldModel = lazyPage(() => import("@/pages/YieldModel"));
const Compliance = lazyPage(() => import("@/pages/Compliance"));
const CertificateVault = lazyPage(() => import("@/pages/CertificateVault"));
const Passports = lazyPage(() => import("@/pages/Passports"));
const VerifyPassport = lazyPage(() => import("@/pages/VerifyPassport"));
const AfricaFX = lazyPage(() => import("@/pages/AfricaFX"));
const MarketDesk = lazyPage(() => import("@/pages/MarketDesk"));
const MetalsDesk = lazyPage(() => import("@/pages/MetalsDesk"));
const GoldBuyingGuide = lazyPage(() => import("@/pages/GoldBuyingGuide"));
const TrackRecord = lazyPage(() => import("@/pages/TrackRecord"));
const PridePage = lazyPage(() => import("@/pages/PridePage"));
const RdiIndex = lazyPage(() => import("@/pages/RdiIndex"));
const Contact = lazyPage(() => import("@/pages/Contact"));
const Intelligence = lazyPage(() => import("@/pages/Intelligence"));
const CompliancePublic = lazyPage(() => import("@/pages/CompliancePublic"));
const TradeCenter = lazyPage(() => import("@/pages/TradeCenter"));
const LegalPage = lazyPage(() => import("@/pages/LegalPages"));
const TradingAdvisor = lazyPage(() => import("@/pages/TradingAdvisor"));
const AfricaNews = lazyPage(() => import("@/pages/AfricaNews"));
const Terminal = lazyPage(() => import("@/pages/Terminal"));
const DeskCalendar = lazyPage(() => import("@/pages/DeskCalendar"));
const DataHome = lazyPage(() => import("@/datasite/DataHome"));
const DataPricing = lazyPage(() => import("@/datasite/DataPricing"));
const DataAbout = lazyPage(() => import("@/datasite/DataAbout"));
const DataLiveData = lazyPage(() => import("@/datasite/DataLiveData"));

export function dataSiteRoutes() {
  return (
    <>
      <Route path="/" element={<DataHome />} />
      <Route path="/pricing" element={<DataPricing />} />
      <Route path="/live-data" element={<DataLiveData />} />
      <Route path="/about" element={<DataAbout />} />
      <Route path="/vdr-rdi" element={<RdiIndex />} />
      <Route path="/rdi" element={<Navigate to="/vdr-rdi" replace />} />
    </>
  );
}

export function flagshipRoutes() {
  return (
    <>
      <Route path="/" element={<Landing />} />
      <Route path="/platform" element={<Navigate to="/" replace />} />
      <Route path="/centre-of-excellence" element={<CentreOfExcellence />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/live-data" element={<LiveData />} />
      <Route path="/about" element={<About />} />
      <Route path="/rdi" element={<RdiIndex />} />
      <Route path="/guides/buying-african-gold" element={<GoldBuyingGuide />} />
      <Route path="/track-record" element={<TrackRecord />} />
      <Route path="/signal" element={<VirtusSignal />} />
      <Route path="/pride" element={<PridePage />} />
      <Route path="/botswana" element={<Navigate to="/centre-of-excellence" replace />} />
      <Route path="/botswana-centre-of-excellence" element={<Navigate to="/centre-of-excellence" replace />} />
      <Route path="/verify" element={<VerifyPassport />} />
      <Route path="/verify/:registryId" element={<VerifyPassport />} />
      <Route path="/for-retailers" element={<LeadLanding variant="retailer" />} />
      <Route path="/for-wholesalers" element={<LeadLanding variant="wholesaler" />} />
    </>
  );
}

export function sharedRoutes() {
  return (
    <>
      <Route path="/wire" element={<Provenance />} />
      <Route path="/wire/archive" element={<ProvenanceArchive />} />
      <Route path="/wire/:commodity" element={<Wire />} />
      <Route path="/collection" element={<Collection />} />
      <Route path="/registry" element={<RegistryPublic />} />
      <Route path="/metals-desk" element={<MetalsDesk />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/intelligence" element={<Intelligence />} />
      <Route path="/compliance" element={<CompliancePublic />} />
      <Route path="/trade-center" element={<TradeCenter />} />
      <Route path="/advisor" element={<TradingAdvisor />} />
      <Route path="/yield" element={<YieldDesk />} />
      <Route path="/legal/privacy" element={<LegalPage kind="privacy" />} />
      <Route path="/legal/ccpa" element={<LegalPage kind="ccpa" />} />
      <Route path="/legal/sanctions" element={<LegalPage kind="sanctions" />} />
      <Route path="/legal/cookies" element={<LegalPage kind="cookies" />} />
      <Route path="/africa-fx" element={<AfricaFX />} />
      <Route path="/africa-news" element={<AfricaNews />} />
      <Route path="/terminal" element={<Terminal />} />
      <Route path="/calendar" element={<DeskCalendar />} />
      <Route path="/african-fx" element={<Navigate to="/africa-fx" replace />} />
      <Route path="/market" element={<MarketDesk />} />
      <Route path="/metals" element={<MetalsDesk />} />
      <Route path="/billing/success" element={<BillingReturn />} />
      <Route path="/forgot-password" element={<PasswordReset mode="forgot" />} />
      <Route path="/reset-password" element={<PasswordReset mode="reset" />} />
      <Route path="/about/data" element={<AboutData />} />
      <Route path="/methodology" element={<AboutData />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/register" element={<Auth mode="register" />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="outlook" element={<MarketOutlook />} />
        <Route path="signals" element={<SignalDesk />} />
        <Route path="research" element={<ResearchTools />} />
        <Route path="indices" element={<Indices />} />
        <Route path="markets" element={<AfricanMarkets />} />
        <Route path="trade" element={<VirtusTrade />} />
        <Route path="admin/revenue" element={<AdminRevenue />} />
        <Route path="price-reference" element={<PriceReference />} />
        <Route path="producers" element={<Producers />} />
        <Route path="yield-model" element={<YieldModel />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="certificates" element={<CertificateVault />} />
        <Route path="passports" element={<Passports />} />
        <Route path="brief" element={<Brief />} />
        <Route path="archive" element={<Archive />} />
        <Route path="verified-data" element={<VerifiedData />} />
        <Route path="origin-premium" element={<OriginPremium />} />
        <Route path="discipline-scorecard" element={<DisciplineScorecard />} />
        <Route path="deal-room" element={<DealRoom />} />
        <Route path="investment-stones" element={<InvestmentStones />} />
        <Route path="accuracy" element={<AccuracyDesk />} />
        <Route path="strategic-briefs" element={<StrategicBriefs />} />
        <Route path="strategic-briefs/:id" element={<StrategicBriefs />} />
        <Route path="fiscal-monitor" element={<FiscalMonitor />} />
        <Route path="weekly-brief" element={<WeeklyBrief />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="orders/new" element={<OrderNew />} />
        <Route path="my-orders" element={<MyOrders />} />
        <Route path="orders/track" element={<OrderTrack />} />
        <Route path="orders/track/:order_id" element={<OrderTrack />} />
        <Route path="admin/commerce" element={<AdminCommerce />} />
        <Route path="rough" element={<RoughPricing />} />
        <Route path="polished" element={<PolishedPricing />} />
        <Route path="auctions" element={<Auctions />} />
        <Route path="odc" element={<ODC />} />
        <Route path="macro" element={<Macro />} />
        <Route path="orders" element={<Orders />} />
        <Route path="registry" element={<Registry />} />
        <Route path="api" element={<ApiAccess />} />
        <Route path="memos" element={<Memos />} />
        <Route path="news" element={<News />} />
        <Route path="alerts" element={<Alerts />} />
      </Route>
      <Route path="/admin" element={<DashboardLayout />}>
        <Route index element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  );
}
